import { notification as antNotification } from 'antd';

export const notification = {
  info: (...args) => antNotification.info(...args),
  success: (...args) => antNotification.success(...args),
  warning: (...args) => antNotification.warning(...args),
  error: (...args) => antNotification.error(...args),
};
